import React from 'react';
import "./download.css"
function Download () {
  return (
     <div className='head'>
      <h1>Time tracking apps</h1>
      <div/>
      <div  className='head'>
      <h3>Install Clockify and track time from anywhere — everything is synced online.</h3>
      </div>
    <div className='btns'>
      <div>
      <button id="btn">Chrome</button>
      <button id="btn">• Firefox</button>
      <button id="btn">• Edge</button>
      <button id="btn">• Mac</button>
      <button id="btn">• Windows</button>
      <button id="btn">• Linux</button>
      <button id="btn">• Andriod</button>
      <button id="btn">• Ios</button>
    </div>
    <div className='btns1'>
      <button className="btns2">Idle detection</button>
      <button className="btns2">Auto start/stop</button>
      <button className="btns2">Offline mode</button>
      <button className="btns2">Default project</button>
      <button className="btns2">Reminders</button>
      <br></br>
      <button className="btns2">Pomodoro timer</button>
      <button className="btns2">Auto tracker</button>
      <button className="btns2">Expenses</button>
      <button className="btns2">Time off</button>
    </div>
     

   <div className='box'>
    <div id="img">
    <img src="https://clockify.me/assets/images/clockify-apps-extension@2x.png"></img>
    </div>
    <div id="text">
    <h1>Browser extension</h1>
    <p>Track time via extension.</p>
     <img src="https://clockify.me/assets/images/chrome-store.svg"></img>
     <img src="https://clockify.me/assets/images/firefox-store.svg"></img>
     <img src="https://clockify.me/assets/images/edge-store-clockify.svg"></img>
    
    </div>
    </div>  
    <hr></hr>
    <div className='box'>
    <div id="img">
    <img src="https://clockify.me/assets/images/clockify-apps-desktop@2x.png"></img>
    </div>
    <div id="text">
    <h1>Desktop app</h1>
    <p>Track time on your computer.</p>
     <img src="https://clockify.me/assets/images/download-app-mac.svg"></img>
     <img src="https://clockify.me/assets/images/download-app-windows.svg"></img>
     <img src="https://clockify.me/assets/images/download-app-linux.svg"></img>
    
    </div>
    </div>  
    

    <div className='box'>
    <div id="img">
    <img src="https://clockify.me/assets/images/clockify-apps-kiosk@2x.png"></img>
    </div>
    <div id="text">
    <h1>Kiosk</h1>
    <p>Set up a shared time clock kiosk on any device..</p>
    <p>TABLET  •  PHONE  •  COMPUTER</p>
     <h5>Learn more</h5>
    
    </div>
    </div>


    <div className='box'>
    <div id="img">
    <img src="https://clockify.me/assets/images/pumble-apps@2x.png"></img>
    </div>
    <div id="text">
    <h1>Chat app</h1>
    <p>Chat via Pumble app (desktop and mobile).</p>
     <img src="https://clockify.me/assets/images/app-store-ios.svg"></img>
     <img src="https://clockify.me/assets/images/play-store-android.svg"></img>
     <img src="https://clockify.me/assets/images/download-app-mac.svg"></img>
     <img src="https://clockify.me/assets/images/download-app-windows.svg"></img>
    </div>
    </div> 

    
    <div class="Footer">
        <div>
            <h1 class="Heading__Two">Start tracking time with the Clockify</h1>
            <div class="Footer__list">
                <li>Unlimited users</li>
                <li>•</li>
                <li>Cancel anytime</li>
                <li>•</li>
                <li>Free forever</li>
            </div>
            <button class="Dark__btn">Get Started - It's Free!</button>
            <i class="fas fa-users"><span>76,318 people signed up last month</span></i>
        </div>
        <div class="Footer__section">
            <div>
                <a href="/"><img src="https://clockify.me/assets/images/clockify-logo.svg" alt="logo"/></a>
                <p><a href="/">Log In</a></p>
                <p><a href="/">Sign up</a></p>
            </div>
            <div></div>
            <div>
                <b><p>Product</p></b>
                <p>Features</p>
                <p>Download</p>
                <p>Integrations</p>
                <p>Extras</p>
            </div>
            <div>
                <b><p>Solution</p></b>
                <p>Time clock</p>
                <p>Timesheet</p>
                <p>Time calculator</p>
                <p>Self-hosting</p>
            </div>
            <div>
                <b><p>Company</p></b>
                <p>About us</p>
                <p>Customers</p>
                <p>Resources</p>
                <p>Blog</p>
            </div>
            <div>
                <b><p>Support</p></b>
                <p>Help</p>
                <p>API</p>
                <p>Contact</p>
                <p><i class="fab fa-twitter"></i><i class="fab fa-youtube"></i></p>
            </div>
        </div>
        <div class="Footer__navigation">
            <div>
                <p>&copy 2020 Clockify</p>
            </div>
            <div></div>
            <div>
                <p>Cookies</p>
            </div>
            <div>
                <p>Terms</p>
            </div>
            <div>
                <p>Privacy</p>
            </div>
            <div>
                <p>Security</p>
            </div>
        </div>
        </div></div>
        </div>
     
    
  );
}

export default Download;
